import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import cns from '../../../node_modules/classnames/index.js';
import { NOOP } from '../../../utils/const.js';
import Spinner from '../../Spinner/Spinner.js';
import useRunningState from '../Hooks/useRunningState.js';
import useChildrenWithText from '../Hooks/useChildrenWithText.js';
import { Emphasis } from '../../types.js';

/**
I pulsanti permettono agli utenti di compiere azioni e fare scelte con un singolo click.

Vedi [Design System di CGN - Pulsanti](https://zeroheight.com/1b5e94371/p/261be1-pulsanti/b/32e1a2)

Proprietà statiche:

- `Button.Emphasis`: valori dell'enum `ButtonEmphasis`.
 */
const ButtonComp = forwardRef((props, ref) => {
    const { emphasis = Emphasis.LOW, primary, vertical, small, running: runningInit, disabled, onClick: onClickInit = NOOP, children, className, blockClassName, tabIndex, } = props;
    const { running, func: onClick } = useRunningState(onClickInit, runningInit);
    const childrenWithText = useChildrenWithText(children);
    const classes = cns(blockClassName, `${blockClassName}--${emphasis.toLowerCase()}`, {
        [`${blockClassName}--primary`]: primary,
        [`${blockClassName}--vertical`]: vertical && emphasis === Emphasis.LOW,
        [`${blockClassName}--small`]: small && emphasis === Emphasis.LOW,
    }, className);
    return (jsxs("button", { ref: ref, type: "button", className: classes, disabled: running || disabled, onClick: onClick, tabIndex: tabIndex, children: [running && jsx("span", { className: `${blockClassName}__loader`, children: jsx(Spinner, { small: true }) }), childrenWithText] }));
});
ButtonComp.displayName = 'Button';
ButtonComp.defaultProps = {
    emphasis: Emphasis.LOW,
    vertical: false,
    primary: false,
    disabled: false,
    small: false,
    running: undefined,
    onClick: NOOP,
    children: undefined,
    blockClassName: 'v2-button',
    className: undefined,
    tabIndex: undefined,
};
const Button = ButtonComp;
Button.Emphasis = Emphasis;

export { ButtonComp, Emphasis as ButtonEmphasis, Button as default };
